import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RadioComponent } from "./radio.component";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        FormsModule
    ],
    declarations: [
        RadioComponent
    ],
    exports: [
        RadioComponent
    ]
})

export class RadioModule {
}
